import { render, staticRenderFns } from "./WorkCurrencyTextField.vue?vue&type=template&id=c2b35420&scoped=true"
import script from "./WorkCurrencyTextField.vue?vue&type=script&lang=js"
export * from "./WorkCurrencyTextField.vue?vue&type=script&lang=js"
import style0 from "./WorkCurrencyTextField.vue?vue&type=style&index=0&id=c2b35420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b35420",
  null
  
)

export default component.exports